/**
 * Which build this client is running.
 *
 * A service worker keeps serving the precached bundle until the user accepts the
 * update, so a device can be stuck on an old build for days. When a bug is
 * reported against "the app", the first question is whether the device is even
 * running the code we think it is — without this, that has to be guessed from
 * the symptom. `__BUILD_ID__` is stamped from the commit at build time and
 * shown on the login screen.
 */

/** Injected by Vite `define`. Falls back when the app runs outside a build. */
declare const __BUILD_ID__: string | undefined;
declare const __APP_VERSION__: string | undefined;

function resolveBuildId(): string {
  try {
    if (typeof __BUILD_ID__ === 'string' && __BUILD_ID__.length > 0) return __BUILD_ID__;
  } catch {
    // ReferenceError outside the bundle — fall through to the unknown marker.
  }
  return 'unknown';
}

function resolveAppVersion(): string {
  try {
    if (typeof __APP_VERSION__ === 'string' && __APP_VERSION__.length > 0) return __APP_VERSION__;
  } catch {
    // ReferenceError outside the bundle
  }
  return '0.1.16';
}

export const BUILD_ID: string = resolveBuildId();
export const APP_VERSION: string = resolveAppVersion();
